import React from 'react'
import Snackbar from "@material-ui/core/Snackbar";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import { useMobileViewport } from "../../../../../util/mobileViewPort";

const useStyles = makeStyles((theme) => ({
  root: {
    width: ({ width }) => width || "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  snackbar: {
    zIndex:9999,
    [theme.breakpoints.down("md")]: {
      top: theme.spacing(9),
      marginLeft: theme.spacing(1),
    },
  },
}));

const ConfigurationToastMessage = ({
  open = false,
  severity = "info",
  snackbarMessage = "",
  handleCloseSnackbar = () => {},
  width = "100",
}) => {
  const classes = useStyles({ width });
  const isMobileView = useMobileViewport();

  const handleClose = () => {
    handleCloseSnackbar(false);
  };

  return (
    <div className={classes.root}>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        style={{ zIndex: "99999" }}
        onClose={handleClose}
        classes={{ root: classes.snackbar }}
        anchorOrigin={{
          vertical: "top",
          horizontal: isMobileView ? "center" : "right",
        }}
      >
        <Alert
          elevation={6}
          style={{ boxShadow: "none" }}I
          variant="filled"
          onClose={handleClose}
          severity={severity}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ConfigurationToastMessage;
